import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import '../../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import Banner from '../../../components/Banner';
import Footer from '../../../components/Footer';
import Sidebar from '../../../components/Sidebar';
import CHANGE_PASSWORD_MUTATION from '../../../graphql/ChangePassword';
import { IsTheaterAdmin } from '../../../utils/Roles';

class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      passwordConfirmation: '',
      actualPassword: '',
      error: null,
      info: null,
    };
  }
  componentWillMount() {
    const theaterId = localStorage.getItem('escenaTheater');

    if (!IsTheaterAdmin() || !theaterId) {
      this.props.history.push('/login');
    }
  }

  onLogout = () => {
    this.props.history.push('/login');
  };

  changePassword = (e) => {
    e.preventDefault();

    const { actualPassword, password, passwordConfirmation } = this.state;
    this.setState({
      error: false,
      info: false,
    });

    let error = null;
    if (actualPassword.length < 1) {
      error = 'Debes ingresar la contraseña actual';
    } else if (password.length < 6) {
      error = 'La contraseña debe tener al menos 6 carácteres';
    } else if (password !== passwordConfirmation) {
      error = 'Las contraseñas no coinciden';
    }

    if (error) {
      this.setState({
        error,
      });
    } else {
      this.props.changePassword({
        variables: {
          oldPassword: actualPassword,
          password,
        },
      }).then(({ data }) => {
        const { message, success } = data.changePassword;
        if (success) {
          this.setState({
            info: message,
          });
        } else {
          this.setState({
            error: message,
          });
        }
      }).catch(() => {
        this.setState({
          error: 'Ocurrió un problema al intentar cambiar la contraseña',
        });
      });
    }
  };

  render() {
    const { error, info } = this.state;
    return (
      <div>
        <Banner />
        <div className="my-propertiess">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-sm-12">
                <Sidebar active="password" onLogout={this.onLogout} />
              </div>

              <div className="col-lg-9 col-md-9 col-sm-12">
                <h1 className="heading">Cambiar contraseña</h1>

                <div className="row">
                  <div className="col-md-12 new-form-container">
                    <div className="row">
                      <div className="col-md-7">
                        <form onSubmit={this.changePassword}>
                          {error && <p className="red">{error}</p>}
                          {info && <p className="green">{info}</p>}
                          <div className="form-group">
                            <label htmlFor="actual_password">Contraseña Actual</label>
                            <input
                              id="actual_password"
                              type="password"
                              name="Password"
                              className="input-text form-control"
                              placeholder="Contraseña actual"
                              value={this.state.actualPassword}
                              onChange={e =>
                                this.setState({ actualPassword: e.target.value })
                              }
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="password">Nueva contraseña</label>
                            <input
                              id="password"
                              type="password"
                              name="NewPassword"
                              className="input-text form-control"
                              placeholder="Contraseña"
                              value={this.state.password}
                              onChange={e =>
                                this.setState({ password: e.target.value })
                              }
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="repeat_password">Repetir contraseña</label>
                            <input
                              id="repeat_password"
                              type="password"
                              name="RepeatrPassword"
                              className="input-text form-control"
                              placeholder="Escriba nuevamente la contraseña"
                              value={this.state.passwordConfirmation}
                              onChange={e =>
                                this.setState({
                                  passwordConfirmation: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div className="form-group">
                            <button type="submit" className="book-btn ">
                              <span className="book-btn-l">
                                <i className="fa fa-check" />
                              </span>
                              <span className="book-btn-r">Cambiar contraseña</span>
                              <div className="clear" />
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default compose(graphql(CHANGE_PASSWORD_MUTATION, {
  name: 'changePassword',
}))(ChangePassword);



// WEBPACK FOOTER //
// ./src/containers/Profile/ChangePassword/index.js